import React from 'react';
import './css/footer.css';

export default function Footer() {
  return (
    <footer className="footer-container">
      <div className="text">
        © 2026 PayITSmart. All rights reserved.
      </div>
    </footer>
  );
}
